// Libs
import React from 'react'

// Imgs
import logo from '../../assets/logos/com-acordo2.svg'

const LogoIcon = (props) => {
  const { width, height, gutter, gutterTop, gutterBottom } = props

  const logoIconStyle = {
    width: `${width}px`,
    height: height ? `${height}px` : '100%',
    margin: `${gutter}px 0`,
    marginTop: `${gutterTop}px`,
    marginBottom: `${gutterBottom}px`,
  }

  return (
    <img style={logoIconStyle} src={logo} alt="" />
  )
}

export default LogoIcon
